import React from "react";
import { FaRegUser } from "react-icons/fa";
import DisplayRating from "./displayrating";

const LandingReviewCard = ({ gadget }) => {
  if (!gadget) return null;

  const { comment, rating, created_at, user } = gadget;
  const fullName = `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();
  const profilePic = user?.profile_picture ?? "";

  // Format the date (optional)
  const formattedDate = created_at
    ? new Date(created_at).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  return (
    <div className="card_container card">
      <div className="card_image">
        {profilePic ? (
          <img
            src={profilePic}
            alt={fullName || "User"}
            loading="lazy"
            className="reviewer_pic"
          />
        ) : (
          <FaRegUser className="default_user_icon" />
        )}
      </div>

      <div className="card_writeup">
        <h3 className="reviewer_name">{fullName || "Anonymous"}</h3>

        <div className="card_rate">
          <DisplayRating rating={rating} />
        </div>

        <p className="review_comment">“{comment}”</p>

        {/* {formattedDate && (
          <small className="review_date">Reviewed on {formattedDate}</small>
        )} */}
      </div>
    </div>
  );
};

export default LandingReviewCard;
